import { useState, useRef, useEffect } from 'react'
import { supabase } from "../supabaseClient";
import { UserAuth } from './AuthContext'
import { useNavigate } from 'react-router-dom'

export function PostBlog() {
  const navigate = useNavigate()
  const { getUser } = UserAuth()
  const [title, setTitle] = useState('')
  const [content, setContent] = useState('')
  const [selectedFile, setSelectedFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState(null);

  const fileInputRef = useRef(null)

  const handleImageUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return

    setSelectedFile(file)
  }

  const handleSubmit = async () => {
    if (!title.trim() || !content.trim()) {
      alert('العنوان والمحتوى مطلوبان')
      return
    }

    setLoading(true)
    let imageUrl = ""

    try {
      if (selectedFile) {
        const fileExt = selectedFile.name.split('.').pop()
        const fileName = `${Date.now()}.${fileExt}`
        const filePath = `blog/${fileName}`

        const { error: uploadError } = await supabase.storage
          .from('blog-images')
          .upload(filePath, selectedFile)

        if (uploadError) throw uploadError

        const { data: publicData } = supabase.storage
          .from('blog-images')
          .getPublicUrl(filePath)

        imageUrl = publicData?.publicUrl || ''
      }

      const { error: insertError } = await supabase.from('posts').insert([
        {
          title,
          content,
          image_url: imageUrl,
        },
      ])

      if (insertError) throw insertError

      alert('تم إرسال التدوينة بنجاح!')
      setTitle('')
      setContent('')
      setSelectedFile(null)
    } catch (err) {
      console.error(err)
      alert('فشل إنشاء التدوينة. تحقق من الكونسول.')
    } finally {
      setLoading(false)
    }
    navigate('/')
  }
  
useEffect(() => {
  async function fetchUser() {
    const u = await getUser();
    if (!u) {
      navigate('/login'); 
    } else {
      setUser(u); // Save logged-in user
    }
  }
  fetchUser();
}, []);

  return (
    <div className="max-w-3xl mx-auto p-4 mt-20">
      <h2 className="text-2xl font-semibold mb-6 text-center">إنشاء تدوينة جديدة</h2>

      <input
        type="text"
        placeholder="عنوان التدوينة"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="w-full p-3 mb-5 border rounded text-lg"
        dir="rtl"
      />

      <textarea
        placeholder="اكتب محتوى التدوينة هنا..."
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className="w-full p-4 mb-6 border rounded text-lg min-h-[350px] resize-y"
        dir="rtl"
        spellCheck={false}
      />

      <input
        type="file"
        ref={fileInputRef}
        onChange={handleImageUpload}
        className="mb-6 w-full"
        accept="image/*"
      />

      {selectedFile && (
        <img
          src={URL.createObjectURL(selectedFile)}
          alt="Preview"
          className="mb-6 w-20 h-20 object-cover rounded shadow-md"
        />
      )}

      <button
        onClick={handleSubmit}
        disabled={loading}
        className={`w-full py-3 rounded text-white text-lg font-semibold transition
          ${loading ? 'bg-gray-500 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
      >
        {loading ? 'جاري الإرسال...' : 'إرسال التدوينة'}
      </button>
    </div>
  )
}
